export default class WebSocketWrapper {
  public socket: WebSocket | null = null;

  constructor() {
    this.socket = null;
  }

  public connect(url: string) {
    if (!this.socket) {
      this.socket = new WebSocket(url);
    }
  }

  public reconnect() {
    if (this.socket?.CLOSED) {
      const url = this.socket.url;
      this.socket = new WebSocket(url);
    }
  }

  public disconect() {
    if (this.socket) {
      this.socket.close();
      this.socket = null;
    }
  }

  public send(message: string) {
    // Every caller sends from a React effect cleanup, which can run while the
    // socket is still CONNECTING (mount and unmount inside the connect window)
    // or after it has closed. WebSocket.send throws InvalidStateError in both
    // cases. Several call sites already hand-roll this readyState check —
    // OptionGroup and useFDSWebSocket — so centralising it here only makes the
    // two that forgot (OptionChain's cleanup, StrategyGroupsList's) silent
    // no-ops instead of throwing.
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(message);
    }
  }

  public on(eventName: string, callback: Function) {
    if (this.socket) {
      this.socket.addEventListener(eventName, callback as any);
    }
  }
}
